import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner-model',
  templateUrl: './spinner-model.component.html',
  styleUrls: ['./spinner-model.component.css']
})
export class SpinnerModelComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
